import moment from 'moment-timezone';
import { Divider, Tooltip } from 'antd';
import {
  DateCreated,
  InfoBlock,
  InfoBlockData,
  InfoBlockName,
  InfoBlocksWrap,
  InfoTitle,
  InvoiceStatus,
} from './styles';
import { useSelector } from 'react-redux';
import { isAdminSelector, isSuperAdminSelector } from 'store/auth';

interface IInfoProps {
  startDate: string;
  estimatedTimeOfArrival: string | null;
  dueDate: string;
  bookingNumber: string;
  totalActualHours: number;
  totalPlannedHours: number;
  totalPrice: number;
  totalActualLaborCost: number;
  totalLaborSalePrice: number;
  totalPlannedLaborCost: number;
  invoiceStatus?: string;
  fullName: string;
  createdAt: string;
}

const Info = ({
  startDate,
  estimatedTimeOfArrival,
  dueDate,
  bookingNumber,
  totalActualHours,
  totalPlannedHours,
  totalPrice,
  totalActualLaborCost,
  totalLaborSalePrice,
  totalPlannedLaborCost,
  invoiceStatus,
  fullName,
  createdAt,
}: IInfoProps): JSX.Element => {
  const isAdmin = useSelector(isAdminSelector);
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const renderCalculations = isSuperAdmin || isAdmin;
  const createdDate = moment(createdAt).format('L hh:mm a');

  return (
    <InfoBlocksWrap>
      <InfoTitle>Details</InfoTitle>
      <InfoBlock>
        <InfoBlockName>Actual Hours</InfoBlockName>
        <InfoBlockData>{totalActualHours} hrs</InfoBlockData>
      </InfoBlock>
      {renderCalculations && (
        <>
          <InfoBlock>
            <InfoBlockName>Planned hours</InfoBlockName>
            <InfoBlockData>{totalPlannedHours} hrs</InfoBlockData>
          </InfoBlock>
          <InfoBlock>
            <InfoBlockName>Labor sell price</InfoBlockName>
            <InfoBlockData>{totalLaborSalePrice}$</InfoBlockData>
          </InfoBlock>
          <InfoBlock>
            <InfoBlockName>Items total price</InfoBlockName>
            <InfoBlockData>{totalPrice}$</InfoBlockData>
          </InfoBlock>
          <InfoBlock>
            <InfoBlockName>Total actual labor cost</InfoBlockName>
            <InfoBlockData>{totalActualLaborCost}$</InfoBlockData>
          </InfoBlock>
          <InfoBlock>
            <InfoBlockName>Labor P&L</InfoBlockName>
            <InfoBlockData>
              {totalPlannedLaborCost - totalActualLaborCost}$
            </InfoBlockData>
          </InfoBlock>
        </>
      )}
      {bookingNumber && (
        <InfoBlock>
          <InfoBlockName>Booking number</InfoBlockName>
          <InfoBlockData>{bookingNumber}</InfoBlockData>
        </InfoBlock>
      )}

      {startDate && (
        <InfoBlock>
          <InfoBlockName>Start Date</InfoBlockName>
          <InfoBlockData>{moment(startDate).format('L')}</InfoBlockData>
        </InfoBlock>
      )}

      <InfoBlock>
        <InfoBlockName>Due Date</InfoBlockName>
        <InfoBlockData>{moment(dueDate).format('L')}</InfoBlockData>
      </InfoBlock>

      {estimatedTimeOfArrival && (
        <InfoBlock>
          <InfoBlockName>ETA</InfoBlockName>
          <InfoBlockData>
            {moment(estimatedTimeOfArrival).format('D MMM (ddd)')}
          </InfoBlockData>
        </InfoBlock>
      )}

      {invoiceStatus && (
        <InfoBlock>
          <InfoBlockName>Status of invoice</InfoBlockName>
          <InfoBlockData>
            <InvoiceStatus>
              {invoiceStatus.length > 13 ? (
                <Tooltip
                  trigger="click"
                  placement="topLeft"
                  title={invoiceStatus}
                >
                  {invoiceStatus.slice(0, 13)}...
                </Tooltip>
              ) : (
                invoiceStatus
              )}
            </InvoiceStatus>
          </InfoBlockData>
        </InfoBlock>
      )}
      <Divider />
      <InfoBlock>
        <InfoBlockName>Record Owner</InfoBlockName>
        <InfoBlockData>{fullName}</InfoBlockData>
      </InfoBlock>
      <InfoBlock>
        <InfoBlockName>Created Date</InfoBlockName>
        <InfoBlockData>
          <DateCreated>{createdDate}</DateCreated>
        </InfoBlockData>
      </InfoBlock>
    </InfoBlocksWrap>
  );
};

export default Info;
